// @ts-nocheck -- Build nélküli, kézzel írt plain JS sziget; a repo checkJs típusellenőrzését szándékosan kihagyjuk (lásd CLAUDE.md).
/*
 * Build nélküli, plain böngésző-JS. A repo oxlint konfigja a TS+build világra
 * van hangolva (stdlib/common wrapperek, no-semicolon, arrow-tiltás), ami itt
 * nem alkalmazható és valódi hibát nem fog (a correctness kategória eleve off).
 * Ezért erre a szigetre kikapcsoljuk. Ha később build kerül fölé, a fájlt
 * TS-re érdemes konvertálni és ezt a sort törölni. Lásd README.
 */
/* oxlint-disable */

/**
 * TudásFM – Csillagsuli ajánló blokk WAV-lejátszója.
 *
 * A TRACKS listából lejátszó-gombokat renderel: kattintásra a hozzá tartozó
 * .wav elindul (egyszerre csak egy szól – a másikra kattintva az előző leáll).
 * Egyetlen újrahasznált Audio elemet használ. Nincs külső függőség, nincs build.
 *
 * A CDN URL-ek EGYELŐRE PLACEHOLDEREK – írd át a valós linkekre.
 */
const TRACKS = [
  { id: 'hu', label: 'Csillagsuli dal', lang: 'HU', src: 'https://cdn.balazs-diak.hu/csillagsuli/music/csillagsuli-dal.wav' },
  // A felirat magyar, a lang badge viszont szándékosan 'EN': a lejátszott felvétel
  // továbbra is az angol dal (starschool-music.wav).
  { id: 'en', label: 'Csillagbuli album', lang: 'EN', src: 'https://cdn.balazs-diak.hu/csillagsuli/music/starschool-music.wav' },
];

function initCsillagsuli() {
  const container = document.getElementById('csillagsuli-tracks');
  if (container === null) {
    return;
  }

  // Egyetlen, újrahasznált lejátszó és az épp szóló track azonosítója.
  const player = new Audio();
  let playingId = null;

  // id → gomb elem, hogy állapotváltáskor frissíthessük a megjelenést.
  const buttons = {};

  const setPlayingState = (id) => {
    playingId = id;
    Object.keys(buttons).forEach((key) => {
      const isActive = key === id;
      buttons[key].classList.toggle('is-playing', isActive);
      buttons[key].setAttribute('aria-pressed', `${isActive}`);
    });
  };

  const play = (track) => {
    // Ha másik track src-je volt betöltve, most cseréljük.
    if (player.src !== track.src) {
      player.src = track.src;
    }
    player.play().catch(() => {
      // Sikertelen lejátszás (pl. placeholder / rossz URL) → állapot vissza.
      setPlayingState(null);
    });
    setPlayingState(track.id);
  };

  const toggle = (track) => {
    if (playingId === track.id) {
      player.pause();
      setPlayingState(null);
      return;
    }
    play(track);
  };

  const buildButton = (track) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'css-track';
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', `Lejátszás: ${track.label}`);

    const icon = document.createElement('span');
    icon.className = 'css-track__icon';
    icon.setAttribute('aria-hidden', 'true');
    // Alap: play háromszög. Lejátszáskor helyette animált equalizer sávok
    // jelennek meg (CSS váltja az is-playing állapot alapján).
    icon.innerHTML =
      '<svg class="css-track__play" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z" /></svg>' +
      '<span class="css-track__eq" aria-hidden="true"><i></i><i></i><i></i><i></i></span>';

    const lang = document.createElement('span');
    lang.className = 'css-track__lang';
    lang.textContent = track.lang;

    const label = document.createElement('span');
    label.className = 'css-track__label';
    label.textContent = track.label;

    button.append(icon, lang, label);
    button.addEventListener('click', () => toggle(track));

    buttons[track.id] = button;
    return button;
  };

  container.replaceChildren(...TRACKS.map(buildButton));

  // A dal végén álljon vissza a gomb alaphelyzetbe.
  player.addEventListener('ended', () => setPlayingState(null));
  // Betöltési/lejátszási hiba (pl. még placeholder URL) esetén se ragadjon be.
  player.addEventListener('error', () => setPlayingState(null));
}

initCsillagsuli();
